import { createAsyncThunk } from "@reduxjs/toolkit";
import { CardNumberElement } from "@stripe/react-stripe-js";
import { merge } from "lodash";
import PartnerApi from "utility/api";

export const checkoutNewOrderRequest = createAsyncThunk(
  "payment/checkoutNewOrderRequest",
  async ({ lines, intentId }, { rejectWithValue }) => {
    try {
      const result = await PartnerApi.newOrderCheckout(merge({ lines }, intentId ? { intentId } : {}));
      return result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const checkoutOrderRequest = createAsyncThunk(
  "payment/checkoutOrderRequest",
  async ({ lines, orderId }, { rejectWithValue }) => {
    try {
      const result = await PartnerApi.orderCheckout({ lines, orderId });
      return result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const paymentRequest = createAsyncThunk(
  "payment/paymentRequest",
  async ({ defaultCard, stripe, elements, expressCheckout, checkout }, { rejectWithValue }) => {
    try {
      const card = elements.getElement(CardNumberElement);

      let res;
      if (!expressCheckout) {
        res = await stripe.confirmCardPayment(checkout.secret, {
          payment_method: defaultCard || { card },
        });
      } else {
        res = await stripe.confirmPayment({
          elements,
          clientSecret: checkout.secret,
          confirmParams: { return_url: `${window.location.origin}/payments/return` },
          redirect: "if_required",
        });
      }

      if (res.error) throw new Error(res.error.message);
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
